import React from 'react';
import { FiPlay, FiPause, FiClock } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useAudio } from '../context/AudioContext';

const CompactEpisodeRow = ({ episode, onClick, isPlayingEpisode }) => {
  return (
    <button 
      onClick={onClick}
      className={`w-full group flex items-center gap-3 p-3 rounded-lg border transition-all duration-300 text-left ${
        isPlayingEpisode 
          ? 'bg-brand-tan/10 border-brand-tan/30 shadow-sm' 
          : 'bg-white border-brand-green/10 hover:border-brand-tan/30 hover:bg-white/80 hover:shadow-md'
      }`}
    >
      {/* Thumbnail with Play Overlay */}
      <div className="relative w-12 h-12 flex-shrink-0 rounded overflow-hidden bg-brand-green/10">
        <img 
          src={episode.image} 
          alt="" 
          className={`w-full h-full object-cover transition-all duration-500 ${
            isPlayingEpisode ? 'opacity-50' : 'group-hover:scale-110'
          }`} 
        />
        <div className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${
          isPlayingEpisode ? 'opacity-100' : 'opacity-0 group-hover:opacity-100 bg-brand-dark/20'
        }`}>
          <div className="bg-brand-tan text-white rounded-full p-1 shadow-sm">
             <SafeIcon icon={isPlayingEpisode ? FiPause : FiPlay} className="w-3 h-3 fill-current" />
          </div>
        </div>
      </div>

      {/* Info */}
      <div className="flex-1 min-w-0">
        <h4 className={`text-sm font-bold truncate font-serif ${
          isPlayingEpisode ? 'text-brand-tan' : 'text-brand-dark group-hover:text-brand-tan transition-colors'
        }`}>
          {episode.title}
        </h4>
        <div className="flex items-center gap-2 text-[10px] text-brand-green/60 font-medium uppercase tracking-wider mt-0.5">
          <span>{episode.pubDate}</span>
          <span className="w-1 h-1 rounded-full bg-brand-tan/30"></span>
          <span className="flex items-center gap-1">
             <SafeIcon icon={FiClock} className="w-2.5 h-2.5" />
             {episode.duration}
          </span>
        </div>
      </div>
    </button>
  );
};

export default CompactEpisodeRow;